/* eslint-disable prefer-arrow-callback, no-underscore-dangle */
import jwt from 'jsonwebtoken'
import { useEffect, useState } from 'react'

import Checkbox from '../../../../factories/components/checkbox'
import NavigationButtons from '../../Common/NavigationButton'
import styles from './styles.scss'

const BraintreeComponent = ({
  clientToken,
  getClientToken = () => {},
  onError = () => {},
  onSuccess = () => {},
  total,
  currency,
  braintreeId,
  onChangeGateway,
  isGuestSignup,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  formType,
  buttonColour,
  buttonTextColour,
  userData,
  is3DSEnabled,
}) => {
  const [isValidPayment, setIsValidPayment] = useState(false)
  const [isSubmitting, setSubmit] = useState(false)
  const [dropInError, setDropInError] = useState(false)
  const [_dropinInstance, setDropinInstance] = useState(null)
  const [paymentSuccess, setPaymentSuccess] = useState(null)
  const [tried, setTried] = useState(false)
  const [saveForLater, setSaveForLater] = useState(false)
  const [showCheckbox, setShowCheckbox] = useState(false)

  // Braintree Drop-in UI config
  let googlePayMerchantId

  if (window._env_) {
    const jwt_env = jwt.decode(window._env_)

    if (jwt_env) {
      googlePayMerchantId = jwt_env.GOOGLE_PAY_MERCHANT_ID
    }
  } else {
    googlePayMerchantId = process.env.GOOGLE_PAY_MERCHANT_ID
  }

  const config = {
    authorization: clientToken,
    container: '#dropin-container',
    threeDSecure: is3DSEnabled,
    card: {
      overrides: {
        styles: {
          input: {
            color: '#4a4a4a',
          },
        },
      },
    },
    googlePay: {
      googlePayVersion: 2,
      ...(googlePayMerchantId ? { merchantId: googlePayMerchantId } : {}),
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPrice: `${total}`,
        currencyCode: currency,
      },
      allowedPaymentMethods: [
        {
          type: 'CARD',
          parameters: {
            billingAddressRequired: false,
          },
        },
      ],
    },
    applePay: {
      displayName: 'Registration',
      paymentRequest: {
        total: {
          label: 'Total',
          amount: `${total}`,
          currencyCode: currency,
        },
      },
    },
    vaultManager: true,
  }

  useEffect(() => {
    if (!clientToken) {
      getClientToken({ vault: !!braintreeId, currency })
    }
  }, [])

  useEffect(() => {
    if (clientToken && !tried && !_dropinInstance) {
      setTried(true)
      braintree.dropin.create(config, (createErr, dropinInstance) => {
        if (createErr) {
          setDropInError(true)
          return
        }
        if (dropinInstance.isPaymentMethodRequestable()) {
          setIsValidPayment(true)
        }

        // biome-ignore lint/complexity/useOptionalChain: TODO
        if (dropinInstance._model._activePaymentMethod && dropinInstance._model._activePaymentMethod.vaulted) {
          setSaveForLater(true)
        }

        if (
          dropinInstance._model.supportedPaymentOptions.length === 1 &&
          dropinInstance._model.supportedPaymentOptions[0] === 'card' &&
          dropinInstance._model._paymentMethods.length === 0 &&
          !isGuestSignup
        ) {
          setShowCheckbox(true)
        }

        dropinInstance.on('paymentOptionSelected', option => {
          const type = option.paymentOption
          const isNewCard = type === 'card'
          if (isNewCard) {
            setSaveForLater(false)
            if (!isGuestSignup) {
              setShowCheckbox(true)
            }
          }
          setIsValidPayment(false)
        })

        dropinInstance.on('paymentMethodRequestable', option => {
          if (option.paymentMethodIsSelected) {
            setSaveForLater(true)
            setShowCheckbox(false)
          }
          setIsValidPayment(true)
        })

        const chooseAnotherPaymentElement = dropinInstance._dropinWrapper.querySelector('[data-braintree-id="toggle"]')

        if (chooseAnotherPaymentElement) {
          chooseAnotherPaymentElement.addEventListener('click', () => {
            dropinInstance.clearSelectedPaymentMethod()
            if (
              dropinInstance._model.supportedPaymentOptions.length === 1 &&
              dropinInstance._model.supportedPaymentOptions[0] === 'card' &&
              !isGuestSignup
            ) {
              setSaveForLater(false)
              setShowCheckbox(true)
            } else {
              setSaveForLater(false)
              setShowCheckbox(false)
            }
          })
        }

        setDropinInstance(dropinInstance)
      })
    }
  }, [clientToken])

  useEffect(() => {
    if (paymentSuccess === false) {
      _dropinInstance.clearSelectedPaymentMethod()
      const chooseAnotherPaymentElement = _dropinInstance._dropinWrapper.querySelector('[data-braintree-id="toggle"]')
      if (chooseAnotherPaymentElement) {
        chooseAnotherPaymentElement.style.display = 'block'
      }
      setIsValidPayment(false)
      setSubmit(false)
      onError()
    }
  }, [paymentSuccess])

  const onCbChange = value => {
    setSaveForLater(value)
  }

  const threeDSecureParameters = {
    amount: total,
    email: userData.email,
    billingAddress: {
      givenName: userData.firstName,
      surname: userData.lastName,
    },
    additionalInformation: {
      shippingGivenName: userData.firstName,
      shippingSurname: userData.lastName,
    },
  }

  return (
    <>
      {dropInError ? (
        <p>
          {`Error Loading Braintree DropIn UI, Click "Back"
            and navigate back to Payment Page.`}
        </p>
      ) : (
        <>
          <div className={styles.dropinContainer} id="dropin-container" />
          {showCheckbox && (
            <Checkbox
              label="Save card details for future use"
              onChange={value => onCbChange(value)}
              value={saveForLater}
            />
          )}
        </>
      )}

      <NavigationButtons
        isContinueDisabled={!isValidPayment}
        preventDefaultOnBack
        hideSubmitButton={isSubmitting}
        submitLabel="Pay Now"
        hideHr
        nonStick
        onSubmit={() => {
          if (!isSubmitting) {
            setSubmit(true)
            _dropinInstance.requestPaymentMethod(
              is3DSEnabled
                ? {
                    threeDSecure: threeDSecureParameters,
                  }
                : {},
              (err, payload) => {
                if (err) {
                  setPaymentSuccess(false)
                  return
                }
                const chooseAnotherPaymentElement =
                  _dropinInstance._dropinWrapper.querySelector('[data-braintree-id="toggle"]')
                if (chooseAnotherPaymentElement) {
                  chooseAnotherPaymentElement.style.display = 'none'
                }

                setPaymentSuccess(true)
                onSuccess({ ...payload, saveForLater })
              }
            )
          }
        }}
        onBack={onChangeGateway}
        buttonColour={buttonColour}
        buttonTextColour={buttonTextColour}
      />
    </>
  )
}

export default BraintreeComponent
